<template>
    <div>
        <b-form @submit="onSubmit"> 
        <b-row>
            <b-col cols="12">    
                <div class="pull-right">
                    <b-button v-if="isFromMessage" v-b-modal.modalReactie variant="themecolor" size="m"><i class="fa fa-comment" aria-hidden="true"></i></b-button>
                </div>     

                <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                    <font-awesome-icon icon="angle-left" size="2x" />
                </b-button>
                <h3 class="text-themecolor my-1">Document {{$route.params.documentId}} <span v-if="!isFromMessage && this.currentDocumentIndex !== -1">({{this.currentDocumentIndex + 1}} van {{documenten.length}})</span></h3>            
            </b-col>
        </b-row>
        <b-row>
            <b-col md="7">
                <b-row v-if="!isFromMessage">
                    <b-button size="sm"  variant="warning" class="mr-1" @click="GoToDocument(previous)" :disabled="previous === 0">Vorige</b-button>
                    <b-button size="sm"  variant="success" class="mr-1" @click="GoToDocument(next)" :disabled="next === 0">Volgende</b-button>
                    <b-button size="sm"  variant="themecolor" class="mr-1" @click="SetDocumentOnverwerkbaar()">Onverwerkbaar</b-button>
                </b-row>
                <b-row>
                    <h5><b>Trigger</b></h5>
                    <b-form-group label-cols label-for="triggerId" class="w-75">                
                        <b-form-input v-model="triggersearch" v-on:keyup="getSearchResults(triggersearch)" type="text" />
                            <div class="category-list" v-bind:key="trigger.triggerId" v-for="trigger in triggers">
                                <router-link :to="{ name: 'documents:trigger', params: { triggerId: trigger.triggerId, triggername: triggersearch, melding: message, isFromMessage: isFromMessage, triggermeldingId: $route.params.triggermeldingId}}" class="nav-link" :class="{ new : trigger.isNew }">{{ trigger.naam }}</router-link>
                            </div>                           
                    </b-form-group>
                <hr>
                </b-row>
                <hr />
            <b-row>
                <b-col md="6" class="pl-0">
                    <b>Klant</b>
                </b-col>
                <b-col v-if="document.klant != null" md="6" class="pl-0">
                    {{document.klant.naam }}
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" class="pl-0">
                    <b>Filename</b>
                </b-col>
                <b-col md="6" class="pl-0">
                    {{document.filename }}
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" class="pl-0">
                    <b>Filecontent</b>
                </b-col>
                <b-col md="6" class="pl-0">
                    <Readmore :text="document.filecontent" />
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" class="pl-0">
                    <b>Pdfcontent</b>
                </b-col>
                <b-col md="6" class="pl-0">
                    <Readmore :text="document.pdfcontent" />
                </b-col>
            </b-row>           
            </b-col>
            <b-col md="5">            
                <div v-if="statusCode" class="alert alert-danger">
                    {{statusCode}}: {{notFoundError}}
                </div>
                <div v-else>
                    <div v-if="!isImageLoaded">
                        <PreLoader/>
                    </div>
                    <b-card v-if="isImageLoaded">
                        <v-zoomer><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100" :class="{ edit : document.isEdited == 1 }" /></v-zoomer>
                    </b-card>
                </div>      
            </b-col>
        </b-row>
        </b-form>
        <b-modal id="modalReactie" ref="priceagreements" :title="`Melding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form autocomplete="off">
                <b-textarea id="reactie" :value="melding" type="text" />
            </b-form>
        </b-modal>        
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import Command from './command'
import PreLoader from '@/components/root/Preloader';
import Readmore from '../../../../components/controls/Readmore.vue';
var timeout = null;

export default {
    name: 'document-detail',
    components: {PreLoader,Readmore},
    props: [ 'isFromMessage', 'melding' ],
    data() {
        return {
            command: new Command(),
            image: '',
            triggersearch: '',
            triggers: [],
            isImageLoaded: false,
            previous: 0,
            next: 0,
            message: '',
            currentDocumentIndex: 0
        }
    },
    computed: {
        ...mapGetters('fmmodule',['document','documenten']),
        ...mapGetters('errors', ['statusCode', 'notFoundError'])
    },
    methods: {
        ...mapActions('fmmodule',['find','update','executeCommand','getImage','errors']),
        goToHome()
        {
            if (this.isFromMessage) {
                this.$router.push({ name: `triggermeldingen:index`});   
            }
            else {
                this.$router.push({ name: `documents:index`});   
            }
               
        },
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'documenten',
                params: vm.command
            };
            vm.update(payload)
                .then(()=> {
                    vm.goTo('index');
                });
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `documenten:${name}` });
        },
        loadImage()
        {
            var vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.getImage(
                {
                    resource:"images",
                    filename: vm.document.filename
                }
                ).then((response) => {
                    this.isImageLoaded = true
                    this.image = response;
                }  )
        },
        async getSearchResults(item){
            var vm = this;        
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                    vm.executeCommand({resource: "triggers/search?name=" + item})
                     .then((response) => {
                         this.triggers = response;
                    }).catch(() => {
                        this.triggers = [];                      
                    });
            }, 750);
        },
        SetDocumentOnverwerkbaar()
        {
            var vm = this;        
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                    vm.executeCommand({resource: "documenten/" + vm.command.id + "/onverwerkbaar"})
                     .then(() => {
                        if(this.next !== 0){
                            this.GoToDocument(this.next)
                        }
                        else{
                            this.goToHome();
                        }                 
                    }).catch(() => {
                   
                    });
            }, 750);
            var index = vm.documenten.findIndex(d => d.id == vm.command.id);
            vm.documenten.splice(index, 1);
        },
        GoToDocument(id) 
        {
            this.$router.push({ name: `documents:detail`, params: { documentId: id } });
        },
    },
    async created() {
        var vm = this;
        this.message = this.$route.params.melding;
        vm.find({
            resource: 'documenten',
            id: this.$route.params.documentId
        })
        .then(() => {
            vm.command = new Command(vm.document);
            this.loadImage();
            if(this.$route.params.triggerId != null && this.$route.params.triggerId != 0)
            {
                vm.find({
                    resource: 'triggers',
                    id: this.$route.params.triggerId
                }).then((result) => { 
                    this.triggersearch = result.naam;
                    this.getSearchResults(result.naam)
                });
            }

   
            this.currentDocumentIndex = vm.documenten.indexOf(vm.documenten.find(item => item.documentId === this.$route.params.documentId)); 
            var indexOfCurrentItem = this.currentDocumentIndex;

            if (indexOfCurrentItem === -1) {
                    return
            }

            this.previous = indexOfCurrentItem === 0 ? 0 : vm.documenten[indexOfCurrentItem - 1].documentId;
            this.next = indexOfCurrentItem + 1 === vm.documenten.length ? 0 : vm.documenten[indexOfCurrentItem + 1].documentId; 
                  
        })
    },
    updated(){
        var vm = this;
        if(vm.document.documentId !== this.$route.params.documentId){
            this.currentDocumentIndex = vm.documenten.indexOf(vm.documenten.find(item => item.documentId === this.$route.params.documentId));
            vm.find({
                resource: 'documenten',
                id: this.$route.params.documentId
            })
            .then(() => {
                vm.command = new Command(vm.document);
                this.loadImage();

                var indexOfCurrentItem = vm.documenten.indexOf(vm.documenten.find(item => item.documentId === this.$route.params.documentId));
                
                if (indexOfCurrentItem === -1) {
                    return
                }

                this.previous = indexOfCurrentItem === 0 ? 0 : vm.documenten[indexOfCurrentItem - 1].documentId;
                this.next = indexOfCurrentItem + 1 === vm.documenten.length ? 0 : vm.documenten[indexOfCurrentItem + 1].documentId;        
            })
        }
    }
}
</script>
<style>
a.nav-link.new {
        color: #5da112;
    font-weight: bold;
    border: 1px solid;
    background: #dddddd;
}
.edit {
    border: 5px solid #45ad17;
}
</style>